/**
 * Design Tokens
 * Autogenerated from tokens.json.
 * DO NOT EDIT!
 */

export const breakpoint = {
	desktop: '980px',
	leftCol: '1140px',
	mobile: '320px',
	mobileLandscape: '480px',
	mobileMedium: '375px',
	phablet: '660px',
	tablet: '740px',
	wide: '1300px',
};
export const height = {
	ctaMedium: '44px',
	ctaSmall: '36px',
	ctaXSmall: '24px',
	iconMedium: '30px',
	iconSmall: '26px',
	iconXSmall: '20px',
	inputMedium: '44px',
	inputXSmall: '24px',
};
export const palette = {
	brand: {
		100: '#001536',
		300: '#041F4A',
		400: '#052962',
		500: '#0077B6',
		600: '#506991',
		800: '#C1D8FC',
	},
	brandAlt: {
		200: '#F3C100',
		300: '#FFD900',
		400: '#FFE500',
	},
	culture: {
		50: '#2B2625',
		100: '#3E3323',
		200: '#574835',
		300: '#6B5840',
		350: '#866D50',
		400: '#866D50',
		450: '#A1845C',
		500: '#EACCA0',
		600: '#E7D4B9',
		700: '#EFE8DD',
		800: '#FBF6EF',
	},
	error: {
		400: '#C70000',
		500: '#FF9081',
	},
	focus: {
		400: '#0077B6',
	},
	labs: {
		200: '#0C7A73',
		300: '#65A897',
		400: '#69D1CA',
	},
	lifestyle: {
		100: '#510043',
		200: '#650054',
		300: '#7D0068',
		400: '#BB3B80',
		450: '#F37ABC',
		500: '#FFABDB',
		600: '#FEC8D3',
		800: '#FEEEF7',
	},
	neutral: {
		0: '#000000',
		7: '#121212',
		10: '#1A1A1A',
		20: '#333333',
		38: '#606060',
		46: '#707070',
		60: '#999999',
		86: '#DCDCDC',
		93: '#EDEDED',
		97: '#F6F6F6',
		100: '#FFFFFF',
	},
	news: {
		100: '#660505',
		200: '#8B0000',
		300: '#AB0613',
		400: '#C70000',
		500: '#FF5943',
		550: '#FF9081',
		600: '#FFBAC8',
		800: '#FFF4F2',
	},
	opinion: {
		100: '#672005',
		200: '#8D2700',
		300: '#C74600',
		400: '#C74600',
		450: '#E05E00',
		500: '#FF7F0F',
		550: '#FF9941',
		600: '#F9B376',
		800: '#FEF9F5',
	},
	specialReport: {
		100: '#222527',
		200: '#303538',
		300: '#3F464A',
		400: '#595C5F',
		450: '#9DA0A2',
		500: '#ABC2C9',
		700: '#E4E5E8',
		800: '#EFF1F2',
	},
	specialReportAlt: {
		100: '#2B2B2A',
		200: '#B9300A',
		300: '#FF663D',
		700: '#EBE6E1',
		800: '#F5F0EB',
	},
	sport: {
		100: '#003C60',
		200: '#004E7C',
		300: '#005689',
		400: '#0077B6',
		500: '#00B2FF',
		600: '#90DCFF',
		800: '#F1F8FC',
	},
	success: {
		400: '#22874D',
		500: '#58D08B',
	},
};
export const size = {
	icon: {
		medium: '30px',
		small: '26px',
		xSmall: '20px',
	},
	medium: '44px',
	small: '36px',
	xSmall: '24px',
};
export const space = {
	0: '2px',
	1: '4px',
	2: '8px',
	3: '12px',
	4: '16px',
	5: '20px',
	6: '24px',
	8: '32px',
	9: '36px',
	10: '40px',
	12: '48px',
	14: '56px',
	16: '64px',
	18: '72px',
	24: '96px',
};
export const typography = {
	body: {
		medium: {
			fontFamily: [
				'GuardianTextEgyptian',
				'Guardian Text Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '17px',
			lineHeight: 1.4,
			fontWeight: 400,
		},
		small: {
			fontFamily: [
				'GuardianTextEgyptian',
				'Guardian Text Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '15px',
			lineHeight: 1.4,
			fontWeight: 400,
		},
		xSmall: {
			fontFamily: [
				'GuardianTextEgyptian',
				'Guardian Text Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '14px',
			lineHeight: 1.4,
			fontWeight: 400,
		},
	},
	fontFamily: {
		body: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		headline: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		textSans: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		titlepiece: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
	},
	fontSize: {
		12: '12px',
		14: '14px',
		15: '15px',
		17: '17px',
		20: '20px',
		24: '24px',
		28: '28px',
		34: '34px',
		42: '42px',
		50: '50px',
		70: '70px',
	},
	fontWeight: {
		bold: 700,
		light: 300,
		medium: 500,
		regular: 400,
	},
	headline: {
		large: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '42px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		medium: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '34px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		small: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '28px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		xLarge: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '50px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		xSmall: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '24px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		xxSmall: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '20px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
		xxxSmall: {
			fontFamily: [
				'GH Guardian Headline',
				'Guardian Egyptian Web',
				'Georgia',
				'serif',
			],
			fontSize: '17px',
			lineHeight: 1.15,
			fontWeight: 500,
		},
	},
	lineHeight: {
		loose: 1.4,
		regular: 1.3,
		tight: 1.15,
	},
	textDecorationThicknessForFontSize: {
		12: '2px',
		14: '2px',
		15: '2px',
		17: '2px',
		20: '3px',
		24: '3px',
		28: '3px',
		34: '4px',
		42: '5px',
		50: '6px',
		70: '6px',
	},
	textSans: {
		large: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '20px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		medium: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '17px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		small: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '15px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		xLarge: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '24px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		xSmall: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '14px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		xxLarge: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '28px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		xxSmall: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '12px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
		xxxLarge: {
			fontFamily: [
				'GuardianTextSans',
				'Guardian Text Sans Web',
				'Helvetica Neue',
				'Helvetica',
				'Arial',
				'Lucida Grande',
				'sans-serif',
			],
			fontSize: '34px',
			lineHeight: 1.3,
			fontWeight: 400,
		},
	},
	titlepiece: {
		large: {
			fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
			fontSize: '70px',
			lineHeight: 1.15,
			fontWeight: 700,
		},
		medium: {
			fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
			fontSize: '50px',
			lineHeight: 1.15,
			fontWeight: 700,
		},
		small: {
			fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
			fontSize: '42px',
			lineHeight: 1.15,
			fontWeight: 700,
		},
	},
};
export const typographyPresets = {
	article15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.4,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	article17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.4,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	articleBold15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.4,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	articleBold17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.4,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	articleBoldItalic15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.4,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	articleBoldItalic17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.4,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	articleItalic15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.4,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	articleItalic17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.4,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	headlineBold14: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold17: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold20: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '20px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold24: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '24px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold28: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '28px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold34: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '34px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold42: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold50: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineBold70: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	headlineLight14: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight17: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight20: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '20px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight24: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '24px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight28: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '28px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight34: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '34px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight42: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight50: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLight70: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'normal',
	},
	headlineLightItalic14: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic17: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic20: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '20px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic24: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '24px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic28: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '28px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic34: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '34px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic42: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic50: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineLightItalic70: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 300,
		fontStyle: 'italic',
	},
	headlineMedium14: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium17: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium20: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '20px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium24: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '24px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium28: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '28px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium34: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '34px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium42: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium50: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMedium70: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'normal',
	},
	headlineMediumItalic14: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic17: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic20: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '20px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic24: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '24px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic28: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '28px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic34: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '34px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic42: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic50: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 500,
		fontStyle: 'italic',
	},
	headlineMediumItalic70: {
		fontFamily: [
			'GH Guardian Headline',
			'Guardian Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	textEgyptian14: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textEgyptian15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textEgyptian17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textEgyptianBold14: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textEgyptianBold15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textEgyptianBold17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textEgyptianBoldItalic14: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	textEgyptianBoldItalic15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	textEgyptianBoldItalic17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'italic',
	},
	textEgyptianItalic14: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textEgyptianItalic15: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textEgyptianItalic17: {
		fontFamily: [
			'GuardianTextEgyptian',
			'Guardian Text Egyptian Web',
			'Georgia',
			'serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSans12: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '12px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans14: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans15: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans17: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans20: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '20px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans24: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '24px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans28: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '28px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSans34: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '34px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'normal',
	},
	textSansBold12: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '12px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold14: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold15: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold17: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold20: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '20px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold24: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '24px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold28: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '28px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansBold34: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '34px',
		lineHeight: 1.3,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	textSansItalic12: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '12px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic14: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '14px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic15: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '15px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic17: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '17px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic20: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '20px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic24: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '24px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic28: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '28px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	textSansItalic34: {
		fontFamily: [
			'GuardianTextSans',
			'Guardian Text Sans Web',
			'Helvetica Neue',
			'Helvetica',
			'Arial',
			'Lucida Grande',
			'sans-serif',
		],
		fontSize: '34px',
		lineHeight: 1.3,
		fontWeight: 400,
		fontStyle: 'italic',
	},
	titlepiece42: {
		fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
		fontSize: '42px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	titlepiece50: {
		fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
		fontSize: '50px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
	titlepiece70: {
		fontFamily: ['GT Guardian Titlepiece', 'Georgia', 'serif'],
		fontSize: '70px',
		lineHeight: 1.15,
		fontWeight: 700,
		fontStyle: 'normal',
	},
};
export const width = {
	ctaMedium: '44px',
	ctaSmall: '36px',
	ctaXSmall: '24px',
	iconMedium: '30px',
	iconSmall: '26px',
	iconXSmall: '20px',
	inputXSmall: '24px',
};
